export const branchContants = {
  GET_ALL_BRANCH: "GET_ALL_BRANCH",
};
